import {ComponentProps, useState} from 'react'
import openEye from 'assets/eye-open.svg'
import closedEye from 'assets/eye-closed.svg'
import FormInput from './FormInput'

type PasswordFormInputProps = ComponentProps<typeof FormInput>

const PasswordFormInput = (props: PasswordFormInputProps) => {
    const [showPassword, setShowPassword] = useState(false)
    const onToggleInputType = () => {
        setShowPassword((it) => !it)
    }

    const inputType = showPassword ? 'text' : 'password'
    return (
        <div className="justify-stretch relative flex flex-1">
            <FormInput {...props} type={inputType} />
            <div className="absolute right-2 top-1/2 w-0 -translate-y-1/2">
                <div className="absolute right-0 top-1/2 w-5 -translate-y-1/2">
                    <img
                        className="w-5"
                        src={showPassword ? openEye : closedEye}
                        alt={'show/hide password'}
                        onClick={onToggleInputType}
                    />
                </div>
            </div>
        </div>
    )
}

export default PasswordFormInput
